import { ChartType } from "../../models/historical-charts/historical-chart.enum"
import { defaultChartOptions, generateCustomSeriesOptions, generateDualAxisChartOptions } from "./charts-options.value"
import { NumberType } from "../../../core/formatters/number.formatter";
import { TimeRange } from "../../models/historical-charts/time-range.enum";

export const HistoricalChartOptions = new Map([
  // ========================================
  // General Dashboard
  // ========================================
  [ChartType.Top5_CMC, defaultChartOptions],
  [ChartType.Total_Volume, defaultChartOptions],
  [ChartType.Crypto_Prices, defaultChartOptions],
  [ChartType.TVL_per_Blockchain, defaultChartOptions],
  [ChartType.TVL_per_Protocols, defaultChartOptions],
  [ChartType.Indices_and_Crypto_Returns, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.BTC_ETH_Correlation, generateCustomSeriesOptions(NumberType.number, 0.2, 0.2)],

  // ========================================
  // Bitcoin Dashboard
  // ========================================
  [ChartType.BTC_Dominance, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.4)],
  [ChartType.BTC_HASHRATE_BY_COUNTRY, defaultChartOptions],
  [ChartType.BTC_MINING_ENERGY_SOURCE, defaultChartOptions],
  [ChartType.BTC_Per_Share_Treasury_Companies, generateCustomSeriesOptions(NumberType.number, 0.2, 0.2)],
  [ChartType.BTC_VARIATION_VS_MINERS_AND_TREASURIES, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.BTC_VARIATIONS_VS_MINING_COMPANIES, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.BTC_VARIATIONS_VS_SP500_GOLD_STOXX50, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.BTC_VARIATIONS_VS_TREASURIES, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.CUMULATED_TOTAL_BTC_TREASURIES_COMPANIES, generateCustomSeriesOptions(NumberType.bitcoinPrice, 0.1, 0)],
  [ChartType.FED_WIRE_VS_BTC_TRANSACTIONS, generateCustomSeriesOptions(NumberType.number, 0.2, 0.2)],
  [ChartType.WHALE_ACCUMULATION, generateDualAxisChartOptions(NumberType.bitcoinPrice, 0.2, 0.2)],

  // ========================================
  // ETFs Dashboard
  // ========================================
  [ChartType.ETF_Bitcoin_AUM, generateCustomSeriesOptions(NumberType.price, 0.1, 0)],
  [ChartType.ETF_Ethereum_AUM, generateCustomSeriesOptions(NumberType.price, 0.1, 0)],
  [ChartType.ETH_Network_Transaction_Counts, generateCustomSeriesOptions(NumberType.number, 0.2, 0)],
  [ChartType.ETF_Flows, generateCustomSeriesOptions(NumberType.price, 0.1, 0.1)],
  [ChartType.ETF_Bitcoin_AUM_Native, generateCustomSeriesOptions(NumberType.bitcoinPrice, 0.1, 0)],
  [ChartType.ETF_Bitcoin_Market_Share, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.ETF_Bitcoin_Total_AUM_Native, generateCustomSeriesOptions(NumberType.bitcoinPrice, 0.1, 0)],
  [ChartType.ETF_Bitcoin_Total_AUM_USD, defaultChartOptions],
  [ChartType.ETF_Ethereum_AUM_Native, generateCustomSeriesOptions(NumberType.ethereumPrice, 0.1, 0)],
  [ChartType.ETF_Ethereum_Market_Share, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.ETF_Ethereum_Total_AUM_Native, generateCustomSeriesOptions(NumberType.ethereumPrice, 0.1, 0)],
  [ChartType.ETF_Ethereum_Total_AUM_USD, defaultChartOptions],

  // ========================================
  // Ethereum Dashboard
  // ========================================
  [ChartType.ETH_NASDAQ_Correlation, generateCustomSeriesOptions(NumberType.number, 0.2, 0.2)],
  [ChartType.ETH_Network_Fees_Paid_USD, defaultChartOptions],
  [ChartType.ETH_Network_Rent_Paid, defaultChartOptions],
  [ChartType.ETH_Network_Rent_Paid_USD, defaultChartOptions],
  [ChartType.ETH_Staked_By_Entity_Percent, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.ETH_Staked_By_Entity, defaultChartOptions],
  [ChartType.Volumes_CEX_DEX_EURONEXT_NYSE, defaultChartOptions],
  [ChartType.ETH_Perpetual_Futures_OpenInterest, generateCustomSeriesOptions(NumberType.price, 0.2, 0.2)],


  // ========================================
  // Stablecoins Dashboard
  // ========================================
  [ChartType.RWA_Total_Stablecoins_Euro_TVL, defaultChartOptions],
  [ChartType.RWA_Total_Stablecoins_TVL, defaultChartOptions],
  [ChartType.Stablecoins_vs_M2, generateDualAxisChartOptions(NumberType.price, 0.2, 0.2)],
  [ChartType.Stablecoins_Per_Network_RWA, defaultChartOptions],
  [ChartType.Stablecoins_Yields, generateCustomSeriesOptions(NumberType.percent, 0.2, 0.2)],
  [ChartType.Stablecoins_Artemis_SectorsVolume, defaultChartOptions],
  [ChartType.Stablecoin_Artemis_Transactions_ByRegionAjusted, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.Stablecoins_Artemis_SupplyUsageUSD, defaultChartOptions],
  [ChartType.Stablecoins_Artemis_VolumeVsOtherFinancialSystems, defaultChartOptions],
  [ChartType.USD_Stablecoin_Marketcap, defaultChartOptions],

  // ========================================
  // RWA Dashboard
  // ========================================
  [ChartType.RWA_Ethereum_Stablecoins_TVL, defaultChartOptions],
  [ChartType.RWA_Holders_Networks, defaultChartOptions],
  [ChartType.RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings, defaultChartOptions],
  [ChartType.RWA_Money_Market_Funds_TVL_Issuers, defaultChartOptions],
  [ChartType.RWA_Money_Market_Funds_TVL_Networks, defaultChartOptions],
  [ChartType.RWA_Money_Market_Funds_TVL_Products, defaultChartOptions],
  [ChartType.RWA_Most_Popular_Networks, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.RWA_Most_Popular_Networks_No_Stablecoins, generateCustomSeriesOptions(NumberType.percent, 0.02, 0)],
  [ChartType.RWA_Private_Credit_NonTokenized_TVL_IMF, defaultChartOptions],
  [ChartType.RWA_Private_Credit_TVL_Network, defaultChartOptions],
  [ChartType.RWA_Private_Credit_TVL_Protocols, defaultChartOptions],
  [ChartType.RWA_Stablecoins_Euro_TVL, defaultChartOptions],
  [ChartType.RWA_Stablecoins_Holders_Networks, defaultChartOptions],
  [ChartType.RWA_Stablecoins_Total_TVL, defaultChartOptions],
  [ChartType.RWA_Total_TVL, defaultChartOptions],
  [ChartType.RWA_Total_TVL_No_Stablecoins, defaultChartOptions],
  [ChartType.RWA_Volume_Stablecoins_VS_Visa, defaultChartOptions],
]);

const defaultTimeRanges: Array<TimeRange> = [TimeRange.All, TimeRange.Year, TimeRange.Quarter, TimeRange.Month];
const chartTypesWithoutTimeRange = [ChartType.RWA_Volume_Stablecoins_VS_Visa, ChartType.RWA_Private_Credit_NonTokenized_TVL_IMF, ChartType.RWA_Money_Market_Funds_NonTokenized_TVL_FitchRatings];
export const getTimeRanges = (type: ChartType): Array<TimeRange> => chartTypesWithoutTimeRange.includes(type) ? [TimeRange.All] : defaultTimeRanges;
// export const excludedSeriesSet = new Set(["BTC Price", "ETH Price"])
